import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import { useSnackbar } from 'notistack';
import { FUNCTION_URL } from '../../Constants/index';
var authProvider = require('../../authProvider');

function TotalStatusesChart () {
    const generateData = async (chartContext, config) => {
        let user_data = authProvider.getData().data;
        let colors = [];

        switch (user_data.role) {
            case 'administrator':
            case 'dg':
                colors = ['#d62f2f', '#004691', '#0074b9', '#008abf', '#009fbb', '#00b3af', '#00c59c', '#15d686', '#607D8B'];
                break;
            case 'magazziniere':
                colors = ['#d62f2f', '#004691', '#00b8ab', '#15d686', '#607D8B'];
                break;
            case 'approvatore':
                colors = ['#d62f2f', '#004691', '#0095bf', '#00b8ab', '#15d686'];
                break;
            default:
                break;
        }

        let params = {
            chartName: 'TotalStatusesChart',
            cod_terr_sap_array: localStorage.getItem('cod_terr_sap')
        }

        let statusCounts;

        //even if the sharts are not configured on Dashboard.js this code still runs, so we need this
        //to avoid unnecessary load on the DB
        if (!['administrator','dg','approvatore'].includes(user_data.role)) {
            statusCounts = await fetch(FUNCTION_URL + '/GetChartData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain',
                    'x-zumo-auth': localStorage.getItem('auth-token')
                },
                body: JSON.stringify(params)
            })
                .then(response => {
                    if (response.status === 200) {
                        return response.text().then(text => JSON.parse(text));
                    }
                    else {
                        return undefined
                    }
                })
                .catch(error => {
                    console.log(error);
                    return error;
                });
        }

        if (statusCounts && statusCounts.message) {
            setOptions({ labels: [] });
            setSeries([]);
            showMessage("TotalStatusesChart: " + statusCounts.message, "error");
        }
        else if (statusCounts && statusCounts.length && statusCounts.length > 0) {
            statusCounts.forEach(s => {
                statuses.push(s._id);
                countStatuses.push(s.count);
            });

            setOptions({
                labels: statuses,
                colors: colors
            });
            setSeries(countStatuses);
        }
        else {
            setOptions({ labels: [] });
            setSeries([]);
        }
    }
    
    const statuses = [];
    const countStatuses = [];
    const {enqueueSnackbar} = useSnackbar();

    const [options, setOptions] = useState({
        colors: ['#004691', '#005ea9', '#0074b9', '#008abf', '#009fbb', '#00b3af', '#00c59c', '#15d686', '#607D8B'],
        chart: {
            id: 'total-statuses',
            events: {
                mounted: generateData.bind(this)
            }
        },
        noData: {
            text: "Nessun dato disponibile",
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
                color: undefined,
                fontSize: '15px',
                fontFamily: undefined
            }
        },
        plotOptions: {
            pie: {
                customScale: 1,
                offsetX: 0,
                offsetY: 0,
                expandOnClick: true,
                dataLabels: {
                    offset: 0,
                    minAngleToShowLabel: 10
                },
                donut: {
                    size: '65%',
                    background: 'transparent',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '22px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            color: undefined,
                            offsetY: -10
                        },
                        value: {
                            show: true,
                            fontSize: '16px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            color: undefined,
                            offsetY: 16,
                            formatter: function (val) {
                                return val
                            }
                        },
                        total: {
                            show: true,
                            showAlways: false,
                            label: 'Totale',
                            fontSize: '22px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            color: '#373d3f',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            }
                        }
                    }
                },
            }
        },
        tooltip: {
            enabled: false
        },
        labels: ['Loading...']
    });
    const [series, setSeries] = useState([1]);

    const showMessage = (message, level) => {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }

    return (
        <Chart options={options} series={series} type="donut" />
    )
}

export default TotalStatusesChart;